
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCrms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplier_company"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seller_company"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"crms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supplier_company"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplier_company"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"seller_company"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seller_company"}}}]}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pricelist"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listname"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"partner_status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"crm_quick_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sales_rep"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custom_order_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"custom_shipping_note"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"credit_limit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"credit_real"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearly_sales_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jan_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"feb_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mar_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"apr_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"may_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jun_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jul_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"aug_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sep_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"oct_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nov_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dec_goal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ytd_sales"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seller_company"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"badge"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"business_profile"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"email"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"website"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"logo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":823}};
    doc.loc.source = {"body":"query GetCrms($supplier_company: ID!, $seller_company: ID!) {\n  crms(\n    where: {\n      supplier_company: { id: $supplier_company }\n      seller_company: { id: $seller_company }\n    }\n  ) {\n    id\n    pricelist {\n      id\n      listname\n    }\n    partner_status\n    crm_quick_note\n    sales_rep\n    custom_order_note\n    custom_shipping_note\n    credit_limit\n    credit_real\n    yearly_sales_goal\n    jan_goal\n    feb_goal\n    mar_goal\n    apr_goal\n    may_goal\n    jun_goal\n    jul_goal\n    aug_goal\n    sep_goal\n    oct_goal\n    nov_goal\n    dec_goal\n    ytd_sales\n    seller_company {\n      id\n      badge\n      business_profile {\n        id\n        company_name\n        city\n        state\n        type\n        phone\n        email\n        website\n        logo {\n          id\n          url\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["GetCrms"] = oneQuery(doc, "GetCrms");
        
